import { FC, ReactPortal, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { useLottie } from 'lottie-react'

import loadingIndicatorSpinner from 'animations/loadingIndicatorSpinner.json'

import { LoadingContainer, LoadingWrapper } from './styles'

const getElem = () => {
  const elem = document.querySelector<HTMLElement>('.main-content-wrapper')

  return elem
}

interface LoadingSpinnerProps {
  text?: string
}

const LoadingSpinner: FC<LoadingSpinnerProps> = ({ text = 'Loading...' }) => {
  const { View } = useLottie({
    animationData: loadingIndicatorSpinner,
    autoPlay: true,
    loop: true
  })

  useEffect(() => {
    const mainElem = window.document.querySelector<HTMLElement>(
      '.main-content-wrapper'
    )

    mainElem?.setAttribute('style', '--over-flow: hidden;')

    return () => {
      mainElem?.setAttribute('style', '')
    }
  }, [])

  return (
    <LoadingWrapper>
      <LoadingContainer>
        {View}
        <span>{text}</span>
      </LoadingContainer>
    </LoadingWrapper>
  )
}

const loadingSpinnerPortal = (
  props?: LoadingSpinnerProps
): ReactPortal | null => {
  const element = getElem() as HTMLElement
  const portal: ReactPortal | null = element
    ? createPortal(<LoadingSpinner {...props} />, element)
    : null

  return portal
}
export default LoadingSpinner

export { loadingSpinnerPortal }
